import { w } from "@/api/words";

import type { SurfaceMeta } from "../registry";

// Объявление поверхности S-45 «Звірки з контрагентами». Тека с этим файлом — и
// есть регистрация (`../registry.ts`). Вход — пункт раздела меню «Довідники»
// и прямой адрес `/s-45` и уведомление 1-го числа (`LEADS_TO`); вкладки «Звірка»
// на `S-12`/`S-16` нет.
export const meta: SurfaceMeta = {
  code: "S-45",
  // Название — слово словаря по коду (`G117`), читается при показе.
  get title_uk() {
    return w("s45_title");
  },
  path: "/s-45",
};
